export const serviceCityServerModel = data => {
    return {
        Name: data && data.name,
        Location: data && data.location,
        AllowCityOnlyAddress: data && data.allowCityOnlyAddress,
        UseAsDefaultCity: data && data.useAsDefaultCity,
    }
}